import SheetWrapper from '@/components/SheetWrapper/index'
export default {
  name: 'card',
  components: {
    SheetWrapper
  },
  props: {
    background: String,
    green: Boolean,
    title: String,
    desc: String,
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    handleBackground() {
      return `background: url('${this.background ||
        'transparent'}') 71px 4px no-repeat;`
    }
  }
}
